<template>
  <div v-if="visible" id="tab-hbl">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div class="operat-wrap">
          <el-dropdown
            no="command1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1);}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{ $t('SeaExport.CodeSearching') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{ $t('SeaExport.CopyFromOtherBill') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyCargoDescriptionAndMarks')">{{ $t('SeaExport.CopyCargoDescriptionAndMarks') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyMbl')">{{ $t('SeaExport.CopyMbl') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            no="originalPrint"
            :disabled="btnPrintDisabled"
            type="primary"
            @click="originalPrint"
          >{{ form.releaseType === 1 ? $t('SeaExport.PrintTheOriginalBl') : $t('SeaExport.TelexRelease') }}
          </el-button>
          <el-button v-show="form.state===2" :disabled="!(form.state===2 && this.$checkPermission(['button_M/HBL_unlock']))" no="Unlock" type="primary" @click="unlock">{{ $t('SeaExport.Unlock') }}</el-button>
          <el-button
            no="showAddressFormatDialog"
            :disabled="readonly||!form.uuid"
            type="primary"
            @click="showAddressFormatDialog"
          >{{ $t('SeaExport.AntiTerroristFormattedAddress') }}</el-button>
          <el-dropdown
            v-if="!OpenXHQDocumentCenter"
            no="command2"
            style="padding-left: 5px;"
            :class="btnBLConfirmDisabled?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command2)"
            @command="p=>{command2=p;commandHandle(command2)}"
          >
            {{ command2 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.InviteToChecktheBL')">{{ $t('SeaExport.InviteToChecktheBL') }}</el-dropdown-item>
              <el-dropdown-item v-permission="['button_M/HBL_confirmBL']" :command="$t('SeaExport.ConfirmChecking')">{{ $t('SeaExport.ConfirmChecking') }}</el-dropdown-item>
              <el-dropdown-item v-permission="['button_M/HBL_identification']" :command="$t('SeaExport.IdentificationList')">{{ $t('SeaExport.IdentificationList') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CheckingHistory')">{{ $t('SeaExport.CheckingHistory') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.UploadGuarantee')">{{ $t('SeaExport.UploadGuarantee') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-menu
            v-if="OpenXHQDocumentCenter && (job.typeHBL === 0 || job.typeHBL === 1)"
            :class="isEdit?'is-disabled not-click':''"
            text-color="#404144"
            active-text-color="#404144"
            mode="horizontal"
            class="el-menu-button el-button el-button--primary el-button--mini"
            style="vertical-align: top"
            @select="XHQDocumentCenterSelectHandler"
          >
            <el-submenu index="index">
              <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.InviteToChecktheBL') }}</span>
              <el-menu-item index="InviteToChecktheBL">{{ $t('SeaExport.InviteToChecktheBL') }}</el-menu-item>
              <el-submenu :index="$t('SeaExport.UploadCustomerFiles')">
                <template slot="title">{{ $t('SeaExport.UploadCustomerFiles') }}</template>
                <el-menu-item index="BillOfLadingConfirmationDocument">{{ $t('Clearing.BillOfLadingConfirmationDocument') }}</el-menu-item>
                <el-menu-item index="CustomerSelfIssuedFiles">{{ $t('SeaExport.CustomerSelfIssuedFiles') }}</el-menu-item>
                <el-menu-item v-if="ToExoSystemJYD" index="OriginBillOfLading">{{ $t('SeaExport.OriginBillOfLading') }}</el-menu-item>
                <el-menu-item index="ShippingOrder">{{ $t('SeaExport.ShippingOrder') }}</el-menu-item>
              </el-submenu>
              <el-menu-item index="CheckTheBLLog">{{ $t('SeaExport.CheckTheBLLog') }}</el-menu-item>
              <el-menu-item index="ConfirmChecking">{{ $t('SeaExport.ConfirmChecking') }}</el-menu-item>
              <el-menu-item index="UploadGuarantee">{{ $t('SeaExport.UploadGuarantee') }}</el-menu-item>
            </el-submenu>
          </el-menu>
          <el-button v-if="OpenXHQDocumentCenter && this.$checkPermission(['button_M/HBL_identification'])" :disabled="isEdit" no="IdentificationList" type="primary" @click="onIdentificationList">{{ $t('SeaExport.IdentificationList') }}</el-button>
          <!-- 对单链接-->
          <el-button v-if="ToExoSystemJYD && (job.typeHBL === 0 || job.typeHBL === 1)" :disabled="isEdit" no="CustomerToOrder" type="primary" @click="onOpenDocLink(0)">{{ $t('SeaExport.CustomerToOrder') }}</el-button>
          <el-button v-if="ToExoSystemJYD && (job.typeHBL === 0 || job.typeHBL === 1)" :disabled="isEdit" no="DesignatedGoodsToBillOfLading" type="primary" @click="onOpenDocLink(1)">{{ $t('SeaExport.DesignatedGoodsToBillOfLading') }}</el-button>
          <el-button
            v-if="OpenXHQDocumentCenter && (job.typeHBL === 0 || job.typeHBL === 1)"
            :disabled="isEdit"
            no="updateBillInfo"
            type="primary"
            @click="pm.updateBillInfo()"
          >{{ $t('SeaExport.ConfirmationBillOfLading') }}</el-button>
          <el-button
            v-if="viewSource === 'SeBooking'"
            v-permission="['button_insurance_toInsure']"
            no="Insure"
            :disabled="isEdit"
            type="primary"
            @click="pm.toInsure()"
          >{{ $t('SeaExport.Insure') }}</el-button>
          <el-menu
            v-permission="['button_EDI_overseasAgentForecast']"
            :class="isEdit?'is-disabled not-click':''"
            text-color="#404144"
            active-text-color="#404144"
            mode="horizontal"
            class="el-menu-button el-button el-button--primary el-button--mini"
            :style="{
              width: 'auto',
              minWidth: $selectByLang('100px', '100px', '100px', '120px', '120px', '120px'),
              verticalAlign: 'top'
            }"
            @select="toOverseaAgeFore"
          >
            <el-submenu index="index">
              <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.OverseasAgeFore') }}</span>
              <el-menu-item :index="$t('SeaExport.Original')">{{ $t('SeaExport.Original') }}</el-menu-item>
              <el-menu-item :index="$t('SeaExport.Correct')">{{ $t('SeaExport.Correct') }}</el-menu-item>
              <el-menu-item :index="$t('CargoMsg.Cargo_Delete')">{{ $t('CargoMsg.Cargo_Delete') }}</el-menu-item>
            </el-submenu>
          </el-menu>
          <el-checkbox
            :value="form.state===2"
            :disabled="true"
          >{{ $t('SeaExport.Locked') }}</el-checkbox>
          <el-checkbox v-model="form.oversea" no="oversea" :disabled="readonly">{{ $t('SeaExport.BlBeReleasedElsewhereOrNot') }}</el-checkbox>
          <el-checkbox v-model="form.manifestEDI" no="manifestEDI" :disabled="readonly">{{ $t('SeaExport.ManifestEdi') }}</el-checkbox>
          <el-checkbox v-model="form.printParam1" no="printParam1" :disabled="readonly">Part of</el-checkbox>
          <el-checkbox v-model="form.printParam2" no="printParam2" :disabled="readonly">{{ $t('SeaExport.ClauseOfNoWoodPackingMaterial') }}</el-checkbox>
          <!-- CARGO-30498 海运出口 HBL箱封信息栏位刷新逻辑调整 -->
          <!-- <el-checkbox
            v-model="form.printParam3"
            no="printParam3"
            :disabled="readonly"
            @change="val=>{pm.chargeContainer(val)}"
          >{{ $t('SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS') }}</el-checkbox> -->
          <el-checkbox
            v-model="form.printParam3"
            no="printParam3"
            :disabled="readonly"
          >{{ $t('SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS') }}</el-checkbox>
          <el-checkbox v-model="chkConsolidationClosed" no="chkConsolidationClosed" :disabled="readonly">{{ $t('SeaExport.AFRTheLastBill') }}</el-checkbox>
          <el-checkbox v-show="job.barge" v-model="form.printParam6" no="printParam6" :disabled="readonly">{{ $t('SeaExport.PrintBargeVesselAndVoyage') }}</el-checkbox>
          <el-checkbox
            no="customerSelfRelease"
            :value="form.customerSelfRelease===1"
            :disabled="readonly"
            @input="isCustomerSelfRelease"
          >{{ $t('SeaExport.CustomerSelfRelease') }}</el-checkbox>
          <el-checkbox
            no="customerSelfRelease2"
            :value="form.customerSelfRelease===2"
            :disabled="readonly"
            @input="isCompanySelfRelease"
          >{{ $t('SeaExport.CompanySelfRelease') }}</el-checkbox>
        </div>
      </div>
    </div>
    <div style="width: fit-content">
      <div style="display: flex">
        <div class="section form-column">
          <el-form label-width="70px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
            <el-form-item class="auto-width">
              <span slot="label" :class="variableCss.shipperLine">{{ $t('SeaExport.Shipper') }}</span>
              <div style="display: flex">
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="shipperCode"
                  v-model="form.shipperCode"
                  :disabled="readonly"
                  no="shipperCode"
                  style="flex:1"
                  :class="importDifferenceField.shipperCode ? 'red-border' : ''"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  :disabled="readonly"
                  no="shipperId"
                  :select-type="selectTypeNames.basic_data_Company"
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  :method-params="{ shipper: true, active: true }"
                  filterable
                  :default-value="form.shipperId||''"
                  tag-name="englishName"
                  style="flex:1;"
                  :class="importDifferenceField.shipperId ? 'red-border' : ''"
                  @parentCallBack="p=>{pm.shipperAutoCompleteChange(p)}"
                />
                <el-button :disabled="readonly" type="primary" style="margin-left: 6px;" @click="pm.onClear(1)">{{ $t('SeaExport.Reset') }}</el-button>
                <char-count inline :form="form" prefix="shipper" />
              </div>
            </el-form-item>
            <el-form-item v-for="count in 7" :key="'shipperLine'+count" :class="'auto-width '+ getClass('shipperLine',count)">
              <special-character-tip :texts="specialCharCheck['shipperLine'+count]">
                <cargo-input
                  :ref="'shipperLine'+count"
                  v-model="form['shipperLine'+count]"
                  :disabled="readonly"
                  :no="'shipperLine'+count"
                  :placeholder="placeholderSFT(count)"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :filter-chars="false"
                  :use-read-only="true"
                  :class="importDifferenceField['shipperLine'+count] ? 'red-border' : ''"
                  @dblclick.native="showShipperDialog"
                  @change="()=>wrapAddr(form,'shipperLine'+count,count+1 > 6 ? null :'shipperLine'+(count+1),maxChars)"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item class="auto-width">
              <span slot="label" :class="variableCss.consigneeLine">{{ $t('SeaExport.Consignee') }}</span>
              <div style="display: flex">
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="consigneeCode"
                  v-model="form.consigneeCode"
                  :disabled="readonly"
                  no="consigneeCode"
                  style="flex:1"
                  :class="importDifferenceField.consigneeCode ? 'red-border' : ''"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  :disabled="readonly"
                  no="consigneeId"
                  :select-type="selectTypeNames.basic_data_Company"
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  :method-params="{ consignee: true, active: true }"
                  filterable
                  :default-value="form.consigneeId||''"
                  tag-name="englishName"
                  style="flex:1;"
                  :class="importDifferenceField.consigneeId ? 'red-border' : ''"
                  @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p)}"
                />
                <el-button type="primary" :disabled="readonly" style="margin-left: 6px;" @click="pm.onClear(2)">{{ $t('SeaExport.Reset') }}</el-button>
                <char-count inline :form="form" prefix="consignee" />
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'consigneeLine'+count"
              v-model="form['consigneeLine'+count]"
              :class="'auto-width ' + getClass('consigneeLine',count)"
            >
              <special-character-tip :texts="specialCharCheck['consigneeLine'+count]">
                <cargo-input
                  :ref="'consigneeLine'+count"
                  v-model="form['consigneeLine'+count]"
                  :disabled="readonly"
                  :no="'consigneeLine'+count"
                  :placeholder="placeholderSFT(count)"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :filter-chars="false"
                  :class="importDifferenceField['consigneeLine'+count] ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                  @change="()=>wrapAddr(form,'consigneeLine'+count,count+1 > 6 ? null :'consigneeLine'+(count+1),maxChars)"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item class="auto-width">
              <span slot="label" :class="variableCss.notifyLine">{{ $t('SeaExport.NotifyParty') }}</span>
              <div>
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="notifyCode"
                  v-model="form.notifyCode"
                  :disabled="readonly"
                  :class="importDifferenceField.notifyCode ? 'red-border' : ''"
                  no="notifyCode"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  :disabled="readonly"
                  no="notifyId"
                  :select-type="selectTypeNames.basic_data_Company"
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  :method-params="{ notify: true, active: true }"
                  filterable
                  :default-value="form.notifyId||''"
                  tag-name="englishName"
                  :class="importDifferenceField.notifyId ? 'red-border' : ''"
                  @parentCallBack="p=>{pm.notifyAutoCompleteChange(p)}"
                />
                <div style="margin-top: 5px">
                  <el-button no="Reset" type="primary" :disabled="readonly" @click="pm.onClear(3)">{{ $t('SeaExport.Reset') }}</el-button>
                  <el-button no="CopyTheConsignee" type="primary" :disabled="readonly" style="margin-left: 5px;" @click="pm.onCopy_consignee()">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
                  <char-count inline :form="form" prefix="notify" />
                </div>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'notifyLine'+count"
              :class="'auto-width ' + getClass('notifyLine',count)"
            >
              <special-character-tip :texts="specialCharCheck['notifyLine'+count]">
                <cargo-input
                  :ref="'notifyLine'+count"
                  v-model="form['notifyLine'+count]"
                  :disabled="readonly"
                  :no="'notifyLine'+count"
                  :placeholder="placeholderSFT(count)"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :filter-chars="false"
                  :class="importDifferenceField['notifyLine'+count] ? 'red-border' : ''"
                  @dblclick.native="showNotifyDialog"
                  @change="()=>wrapAddr(form,'notifyLine'+count,count+1 > 6 ? null :'notifyLine'+(count+1),maxChars)"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item class="auto-width">
              <span slot="label" :style="variableCss.agentPartyLine ?'': 'color:#404144!important;' " :class="variableCss.agentPartyLine">{{ $t('SeaExport.AgentInfo') }}</span>
              <div style="text-align: right">
                <el-button no="onClear4" type="primary" :disabled="readonly" style="min-width:50px;margin-right: 5px" @click="pm.onClear(4)">{{ $t('SeaExport.Reset') }}</el-button>
                <el-dropdown
                  no="command3"
                  :class="readonly?'not-click':''"
                  split-button
                  type="primary"
                  :disabled="readonly"
                  @click="commandHandle(command3)"
                  @command="p=>{command3=p;commandHandle(command3)}"
                >
                  {{ command3 }}
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="$t('SeaExport.CopyMblConsignee')">{{ $t('SeaExport.CopyMblConsignee') }}</el-dropdown-item>
                    <el-dropdown-item :command="$t('SeaExport.CopyNominatedAgentInfo')">{{ $t('SeaExport.CopyNominatedAgentInfo') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'agentPartyLine'+count"
              :class="'auto-width ' + getClass('agentPartyLine',count)"
            >
              <cargo-input
                :ref="'agentPartyLine'+count"
                v-model="form['agentPartyLine'+count]"
                :disabled="readonly"
                :no="'agentPartyLine'+count"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                :filter-chars="false"
                @dblclick.native="showAgentPartyDialog"
                @change="()=>wrapAddr(form,'agentPartyLine'+count,count+1 > 6 ? null :'agentPartyLine'+(count+1),maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0">
              <span style="color:#404144">ALSO NOTIFY</span>
            </el-form-item>
            <el-form-item class="auto-width">
              <cargo-rich-textarea
                v-model="form.alsoNotify"
                :disabled="readonly"
                no="alsoNotify"
                :text-chars="0"
                wrap-symbol="r"
                auto-half-word
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{form.alsoNotify=val},notUppercaseShipperConsigneNotify,{warningCount:45,autoUppercase:notUppercaseShipperConsigneNotify,autoHalfWord:true})"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="125px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.CargoInfo') }}</span>
            <el-form-item
              :label="$t('SeaExport.NumberOfPackagesOnBl')"
              :class="variableCss.quantity"
            >
              <auto-number-input
                v-model="form.quantity"
                no="quantity"
                :precision="0"
                :min="0"
                :disabled="!isJydEditJobFields"
                :class="importDifferenceField.quantity ? 'red-border' : ''"
                @change="pm.quantity_Change()"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')" :class="variableCss.packing">
              <!-- <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Packing"
                filterable
                :default-value="form.packing"
                style="width:100%;"
                @parentCallBack="p=>{pm.packing_Change(p)}"
              /> -->
              <cargo-packing-select
                no="packing"
                :default-value="form.packing"
                :class="importDifferenceField.packing ? 'red-border' : ''"
                @change="p => {pm.packing_Change(p)}"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.PackageDisplayName')"
            >
              <el-input v-model="form.packingName" :class="importDifferenceField.packingName ? 'red-border' : ''" no="packingName" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Pieces2')" :class="variableCss.insideQuantity">
              <auto-number-input
                v-model="job.insideQuantity"
                no="insideQuantity"
                :precision="0"
                :min="0"
                :class="importDifferenceField.insideQuantity ? 'red-border' : ''"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PiecesType2')" :class="variableCss.insidePacking">
              <!-- <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Packing"
                filterable
                :default-value="form.insidePacking"
                style="width:100%;"
                @parentCallBack="p=>{form.insidePacking=p.value}"
              /> -->
              <cargo-packing-select
                :default-value="form.insidePacking"
                no="insidePacking"
                :class="importDifferenceField.insidePacking ? 'red-border' : ''"
                @change="p => {form.insidePacking=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Weight')" :class="variableCss.weight">
              <div class="form-item-input" :class="readonly ? 'input-disabled': importDifferenceField.weight ? 'red-border' : ''">
                <el-input-number
                  v-model="form.weight"
                  no="weight"
                  :disabled="!pm.isCanEditQwc || !isJydEditJobFields"
                  :precision="3"
                  :min="0"
                  :controls="false"
                  style="flex:1"
                  @change="p=>{pm.changeBillOfLadingSynJob(true);pm.calculateChargeWeight();}"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Cubage')" :class="variableCss.cubage">
              <div class="form-item-input" :class="readonly ? 'input-disabled': importDifferenceField.cubage ? 'red-border' : ''">
                <el-input-number
                  v-model="form.cubage"
                  no="cubage"
                  :disabled="!pm.isCanEditQwc || !isJydEditJobFields"
                  :precision="3"
                  :min="0"
                  :controls="false"
                  style="flex: 1"
                  @change="p=>{pm.changeBillOfLadingSynJob(true);pm.calculateChargeWeight();}"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChargedWeightRT')">
              <div class="form-item-input" :class="readonly ? 'input-disabled': importDifferenceField.chargeWeight ? 'red-border' : ''">
                <el-input-number
                  v-model="form.chargeWeight"
                  no="chargeWeight"
                  :precision="3"
                  :min="0"
                  style="flex: 1"
                  :controls="false"
                  @change="pm.changeBillOfLadingSynJob(false)"
                />
                <span>M/T</span>
              </div>
            </el-form-item>
            <el-form-item
              label-width="0"
              class="auto-width"
              :class="variableCss.cargoEnglishName"
            >
              <el-button
                v-show="isEdit"
                no="getMBLInfoEName"
                type="primary"
                style="float:right"
                @click="pm.getMBLInfo('EName')"
              >
                {{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromMbl') }}
              </el-button>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')" :class="'auto-width '+variableCss.cargoEnglishName">
              <special-character-tip :texts="specialCharCheck.cargoEnglishName">
                <cargo-rich-textarea
                  ref="cargoTextarea1"
                  v-model="form.cargoEnglishName"
                  no="cargoEnglishName"
                  :show-count="true"
                  :text-chars="englishNameMaxChars"
                  :warning-count="englishNameWarningCount"
                  wrap-symbol="r"
                  :disabled="!isEdit"
                  :auto-uppercase="isUppercaseByConfig"
                  auto-half-word
                  style="height: 110px"
                  :class="importDifferenceField.cargoEnglishName ? 'red-border' : ''"
                  @change="p=>{syncAms('cargoEnglishName');pm.cargoEnglishNameBlurHandler()}"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val;syncAms('cargoEnglishName')},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:isUppercaseByConfig,warningCount: englishNameWarningCount,maxChar: englishNameMaxChars})"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item
              label-width="0"
              class="auto-width"
              :class="variableCss.mark"
            >
              <el-button
                v-show="isEdit"
                no="getMBLInfoMark"
                type="primary"
                style="float:right;margin-left:5px"
                @click="pm.getMBLInfo('mark')"
              >
                {{ $t('SeaExport.CopyMarksFromMbl') }}
              </el-button>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Marks')" :class="'auto-width '+variableCss.mark">
              <special-character-tip :texts="specialCharCheck.mark">
                <cargo-rich-textarea
                  ref="cargoTextarea2"
                  v-model="form.mark"
                  no="mark"
                  :show-count="true"
                  :text-chars="markMaxChars"
                  :warning-count="markWarningCount"
                  wrap-symbol="r"
                  :disabled="!isEdit"
                  :auto-uppercase="isUppercaseByConfig"
                  auto-half-word
                  style="height: 110px"
                  :class="importDifferenceField.mark ? 'red-border' : ''"
                  @change="pm.markBlurHandler()"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:isUppercaseByConfig,warningCount: markWarningCount,maxChar: markMaxChars})"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CapitalizedNumbersOfPackages')" class="auto-width">
              <el-input v-model="form.quantitySum" :class="importDifferenceField.quantitySum ? 'red-border' : ''" :disabled="true" />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form label-width="100px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.TransportInfo') }}</span>
            <el-form-item label="HB/L NO.">
              <el-input v-model="form.hblNbr2" no="hblNbr2" :disabled="hblNoDisabled || readonly" />
            </el-form-item>
            <el-form-item label="SO NO." :class="variableCss.soNoTitle">
              <el-input :value="job.soNo.replace(/\n/g, ',')" :disabled="true" :class="variableCss.soNo" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HBLBillOfLadingNum')">
              <el-input v-model="form.serialNo" :class="importDifferenceField.serialNo ? 'red-border' : ''" no="serialNo" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Vessel')" :class="variableCss.vesselTitle">
              <cargo-advance-select
                no="vessel"
                :disabled="readonly||!pm._lclslaveEnabled"
                :select-type="selectTypeNames.basic_data_Vessel"
                filterable
                :allow-create="pm._allowEditingVessel"
                :default-value="job.vessel"
                style="width:100%;"
                :cache="false"
                :static-options="pm.vesselList"
                @parentCallBack="p=>{pm.onVesselSelectionChange(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Voyage')" :class="variableCss.voyageFlightTitle">
              <cargo-advance-select
                ref="voyageFlight"
                no="voyageFlight"
                :static-options="pm._voyages || []"
                :cache="false"
                :default-value="job.voyageFlight"
                :disabled="readonly||!pm._lclslaveEnabled"
                filterable
                clearable
                :allow-create="pm.editVoyageMode===1"
                tag-name="voyageNo"
                tag-value="voyageNo"
                :filter-tag-names="['voyageNo']"
                @focus="pm.txtVoyageFocusInHandler()"
                @parentCallBack="p=>{pm.onVoyagaFlightChange(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfDeparture')">
              <el-input :value="sailingDate" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceiptOnBl')" :class="variableCss.dispatchingPlace">
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.dispatchingPlaceCode||''"
                tag-name="englishName"
                :class="importDifferenceField.dispatchingPlaceCode ? 'red-border' : ''"
                no="serialNo"
                @parentCallBack="p=>{pm.portChange(p, 'dispatchingPlace')}"
              />
              <el-input v-model="form.dispatchingPlace" :disabled="readonly" :filter-chars="false" :class="importDifferenceField.dispatchingPlace ? 'red-border' : ''" no="dispatchingPlace" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingOnBl')" :class="variableCss.loadingPort">
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.loadingPortCode||''"
                tag-name="englishName"
                no="loadingPortCode"
                :class="importDifferenceField.loadingPortCode ? 'red-border' : ''"
                @parentCallBack="p=>{pm.portChange(p, 'loadingPort')}"
              />
              <el-input v-model="form.loadingPort" :disabled="readonly" :filter-chars="false" :class="importDifferenceField.loadingPort ? 'red-border' : ''" no="loadingPort" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfDischargeOnBl')" :class="variableCss.dischargingPort">
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode||''"
                tag-name="englishName"
                no="dischargingPortCode"
                :class="importDifferenceField.dischargingPortCode ? 'red-border' : ''"
                @parentCallBack="p=>{pm.portChange(p, 'dischargingPort')}"
              />
              <el-input v-model="form.dischargingPort" :disabled="readonly" :filter-chars="false" :class="importDifferenceField.dischargingPort ? 'red-border' : ''" no="dischargingPort" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfDeliveryOnBl')" :class="variableCss.destinationPort">
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.destinationPortCode||''"
                tag-name="englishName"
                no="destinationPortCode"
                :class="importDifferenceField.destinationPortCode ? 'red-border' : ''"
                @parentCallBack="p=>{pm.portChange(p, 'destinationPort')}"
              />
              <el-input v-model="form.destinationPort" :disabled="readonly" :filter-chars="false" :class="importDifferenceField.destinationPort ? 'red-border' : ''" no="destinationPort" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlFinalDestination')">
              <el-input v-model="form.destinationPlace" :disabled="readonly" :filter-chars="false" :class="importDifferenceField.destinationPlace ? 'red-border' : ''" no="destinationPlace" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MethodOfHblPayment')">
              <cargo-advance-select
                :disabled="readonly"
                no="paymentTermHBL"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :default-value="job.paymentTermHBL"
                :allow-create="true"
                style="width:100%;"
                @parentCallBack="p=>{pm.paymentSelectHblChange(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfHblPayment2')">
              <el-input v-model="form.paymentPlaceBL" :disabled="readonly" :class="importDifferenceField.paymentPlaceBL ? 'red-border' : ''" no="paymentPlaceBL" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TransportationClause')">
              <el-input v-model="job.freightTermHBL" :disabled="readonly" no="freightTermHBL" />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.NoOfOriginalBls')"
              :class="variableCss.BLNumber"
            >
              <el-input v-model="form.blNumber" :disabled="readonly" :class="importDifferenceField.blNumber ? 'red-border' : ''" no="blNumber" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfIssue')">
              <el-input v-model="form.signPlaceBL" :disabled="readonly" :class="importDifferenceField.signPlaceBL ? 'red-border' : ''" no="signPlaceBL" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfIssue')">
              <el-date-picker v-model="form.signDateBL" :disabled="readonly" :class="importDifferenceField.signDateBL ? 'red-border' : ''" no="signDateBL" type="date" value-format="yyyy-MM-dd" style="width:100%;" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlRemarks')" :class="variableCss.remarks">
              <cargo-input
                v-model="form.remarks"
                :disabled="readonly"
                no="remarks"
                type="textarea"
                :rows="5"
                :filter-chars="false"
                :class="importDifferenceField.remarks ? 'red-border' : ''"
                :use-read-only="true"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HsCode')">
              <el-input
                v-if="syncHblHsCodeEdit"
                v-model="form.hsCode"
                :disabled="readonly"
                no="hsCode"
                type="textarea"
                :rows="5"
                style="width: 100%"
                :class="importDifferenceField.hsCode ? 'red-border' : ''"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),form.hsCode,val=>{form.hsCode=val})"
              />
              <el-input
                v-else
                v-model="job.hsCode"
                :disabled="readonly"
                no="hsCode"
                type="textarea"
                :rows="5"
                style="width: 100%"
                :class="importDifferenceField.hsCode ? 'red-border' : ''"
                @input="val=>{hsCodeChangeHandle(val)}"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),job.hsCode,val=>{hsCodeChangeHandle(val)})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CheckingQuestions')">
              <el-input
                v-model="form.customerCfmException"
                :disabled="readonly"
                no="customerCfmException"
                type="textarea"
                :rows="5"
                :class="importDifferenceField.customerCfmException ? 'red-border' : ''"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.CheckingQuestions'),form.customerCfmException,val=>{form.customerCfmException=val})"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form label-width="108px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.OtherInfo') }}</span>
            <el-form-item :label="$t('SeaExport.BlType')">
              <el-select
                v-model="form.releaseType"
                :disabled="readonly"
                no="releaseType"
                :class="importDifferenceField.releaseType ? 'red-border' : ''"
                @change="val=>{pm.cmbreleaseTypeMBL_changeHandler(val)}"
              >
                <el-option
                  v-for="(item,index) in blModeList"
                  :key="index"
                  :label="item.name"
                  :value="item.serialNumber"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlType2')">
              <cargo-advance-select
                :disabled="readonly"
                no="issuerBL"
                :select-type="selectTypeNames.basic_data_OrderFormType"
                filterable
                :default-value="form.issuerBL"
                style="width:100%;"
                :tag-name="isZh ? 'name' : 'englishName'"
                :clearable="false"
                :class="importDifferenceField.issuerBL ? 'red-border' : ''"
                @parentCallBack="p=>{pm.cmbissuerHBL_changeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlProperty')">
              <el-select
                :value="job.typeHBL||1"
                no="typeHBL"
                :disabled="cmbtypeHBLDisabled || readonly"
                :clearable="false"
                @input="val=>{pm.cmbtypeHBLChangeHandler(val)}"
              >
                <el-option
                  v-for="(item,index) in BILL_TYPES"
                  :key="index"
                  :label="isZh ? item.chineseName : item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="job.jointMasterHBLUuid" :label="$t('SeaExport.HBLHBR')">
              <el-input :value="job.jointMasterHBL?job.jointMasterHBL.jobNo:''" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CheckingStatus')" class="red">
              <div style="display: flex">
                <el-input :value="lblCfrState" :disabled="true" style="flex: 1" />
                <el-link
                  v-if="showXhqOverseasAgentFeedbackLink"
                  no="xhqOverseasAgentFeedbackLink"
                  style="color: blue;margin-left: 5px"
                  @click="xhqShowOverseasAgentFeedbackDialog"
                >{{ $t('SeaExport.View') }}
                </el-link>
              </div>
            </el-form-item>

            <!-- 提单签发状态 -->
            <el-form-item :label="$t('SeaExport.BillLadingIssued')" class="red">
              <el-input :value="billLadingIssued" :disabled="true" />
            </el-form-item>

            <el-form-item label-width="0">
              <el-button
                v-if="OpenXHQDocumentCenter && (job.typeHBL === 0 || job.typeHBL === 1)"
                v-permission="['button_HBL_surrendered']"
                :disabled="isEdit"
                no="surrendered"
                type="primary"
                @click="pm.toSurrendered()"
              >{{ $t('SeaExport.Surrendered') }}</el-button>
            </el-form-item>

            <el-form-item :label="$t('SeaExport.ReleasingStatus')" class="red">
              <el-input :value="lblReleaseState" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.RequestReleaseState')" class="red">
              <el-input :value="form.requestReleaseState === 0 ? $t('SeaExport.NotApplying') : $t('SeaExport.Requested')" :disabled="true" />
              <span style="float:left;margin-left:-85px">{{ job.jointMasterHBLUuid ? $t('SeaExport.TicketHasMerged') : (job.typeHBL === BillType.SPLIT_BILL_TYPE.code) ? $t('SeaExport.TicketHasSplit') : '' }}</span>
              <cargo-button-container
                no="requestReleaseState"
                :disabled="btnBLConfirmDisabled || !cooperateEdit"
                style="float:right;margin-left:5px"
                @click="pm.btnRequestReleasingClickHandler()"
              >
                <el-button v-permission="['button_M/HBL_SingleReleaseHBL']" :disabled="job.jointMasterHBLUuid || job.typeHBL === BillType.SPLIT_BILL_TYPE.code" type="primary">
                  {{ form.requestReleaseState === 0 ? $t('SeaExport.ApplyForARelease') : $t('SeaExport.WithdrawTheRequestForRelease') }}
                </el-button>
              </cargo-button-container>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ReleaseEligibleStatus')" class="red">
              <el-input :value="releaseEligibleLabel" :disabled="true" />
            </el-form-item>
            <el-form-item
              v-if="guaranteeConfigEnable"
              :label="$t('SeaExport.LongTermGuaranteeState')"
              class="red"
            >
              <el-input :value="SystemConstants.LONG_TERM_GUARANTEE_STATE_MAP.get(longTermGuaranteeState)" :disabled="true" />
            </el-form-item>
            <el-form-item
              v-if="guaranteeConfigEnable"
              :label="$t('SeaExport.SingleTicketGuaranteeState')"
              class="red"
            >
              <el-input :value="SystemConstants.SINGLE_TICKET_GUARANTEE_STATE_MAP.get(singleTicketGuaranteeState)" :disabled="true" />
            </el-form-item>
            <el-form-item>
              <el-checkbox
                :value="form.releaseReview===1"
                :disabled="true"
                style="margin-right: 6px;"
              >{{ $t('SeaExport.DataSent') }}</el-checkbox>
              <el-checkbox :value="form.payable" :disabled="true" style="margin-right: 6px;">{{ $t('SeaExport.Completed') }}</el-checkbox>
              <el-checkbox :value="form.withhold" :disabled="true" style="margin-right: 0px;">{{ $t('SeaExport.CargoDetention') }}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfcompletion')">
              <el-date-picker
                v-model="form.agreePayDate"
                no="agreePayDate"
                :disabled="isDatePickerDisabled"
                type="date"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                @input="handleDateChange"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfCargoDetention')">
              <el-date-picker
                v-model="form.withholdDate"
                no="withholdDate"
                :disabled="true"
                type="date"
                style="width: 100%;"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ParamRemark')">
              <el-select v-model="form.printParam4" :disabled="readonly" :class="importDifferenceField.printParam4 ? 'red-border' : ''" no="printParam4" :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')" filterable allow-create>
                <el-option
                  v-for="(item,index) in pm.printParam4Type"
                  :key="index"
                  :label="item.label"
                  :value="item.data"
                  :class="importDifferenceField.printParam4 ? 'red-border' : ''"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.GenerationOfABillOfLading')">
              <el-select v-model="form.printParam5" :disabled="readonly" :class="importDifferenceField.printParam5 ? 'red-border' : ''" no="printParam5" :placeholder="readonly ? '': $t('CargoMsg.Cargo_PleaseSelect')">
                <el-option
                  v-for="(item,index) in pm.printParam5Type"
                  :key="index"
                  :label="item.label"
                  :value="item.data"
                  :class="importDifferenceField.printParam5 ? 'red-border' : ''"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShippingCompanySCAC')">
              <el-input :value="txtCarrierScAc" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseasAgentSCAC')">
              <el-input :value="txtBookingAgentScAc" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShipperContactTelNo')">
              <el-input v-model="form.shipperTel" :class="importDifferenceField.shipperTel ? 'red-border' : ''" :disabled="readonly" no="shipperTel" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ConsigneeContactTelNo')">
              <el-input v-model="form.consigneeTel" :class="importDifferenceField.consigneeTel ? 'red-border' : ''" :disabled="readonly" no="consigneeTel" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NotifyPartyTelNo')">
              <el-input v-model="form.notifyTel" :class="importDifferenceField.notifyTel ? 'red-border' : ''" :disabled="readonly" no="notifyTel" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CNTRNOSSEALNOS')">
              <el-button
                :disabled="readonly"
                type="primary"
                @click="getPackingInformation"
              >
                {{ $t('SeaExport.GetPackingInformation') }}
              </el-button>
            </el-form-item>
            <el-form-item>
              <cargo-input
                v-model="form.container"
                :disabled="readonly"
                no="container"
                :auto-uppercase="true"
                type="textarea"
                :rows="5"
                style="width:100%"
                :filter-chars="false"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.CNTRNOSSEALNOS'),form.container,val=>{form.container=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ReasonOfCargoDetention')">
              <el-input :value="form.withholdReason" type="textarea" :rows="5" :disabled="true" style="width: 100%;" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_OrderModificationTimes')">
              <auto-number-input v-model="form.modificationCount" :disabled="readonly" :precision="0" :min="0" no="modificationCount" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PortRequirement')">
              <el-input v-model="form.portRequirement" :disabled="readonly" no="portRequirement" type="textarea" :rows="5" />
              <div style="display: flex;line-height: 16px;margin-top: 5px;cursor: pointer;" @click="downloadAttachment(form.regionWarehouseMappingUuid)">
                <i class="el-icon-paperclip" style="font-size: 16px;" />
                <div style="font-size: 12px;text-decoration: underline;color: blue;">{{ $t('SystemMaintenance.PortRequirementsRelatedDocuments') }}</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="section">
        <span class="title">{{ $t('SeaExport.freightChargesInfo') }}</span>
        <div style="display:flex;flex-direction:column">
          <div v-show="isEdit&&form.uuid" style="padding:5px 0">
            <el-button no="Add" type="primary" @click="showEditDialog(true)">{{ $t('SeaExport.Add') }}</el-button>
            <el-button no="Edit" type="primary" @click="showEditDialog(false)">{{ $t('SeaExport.Edit') }}</el-button>
            <el-button no="Delete" type="danger" @click="remove">{{ $t('SeaExport.Delete') }}</el-button>
          </div>
          <cargo-ag-grid
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="finalRowData"
            style="width:100%;height:350px"
            @gridReady="params=>{gridApi=params.api}"
          />
          <div style="padding:5px 0;font-size:12px">
            <span style="color:#0A0AFF">{{ $t('SeaExport.freightChargesUSDTotal') }}</span>
            <i style="margin-left:15px;margin-right:5px">{{ form.freightChargeEnUpper }}</i>
            <i>({{ NumberUtils.formatNumber(form.freightChargeTotal, 2) }})</i>
          </div>
        </div>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :disabled="readonly"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="confirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="close"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      :params="form"
      @callback="codeSearchCallback"
    />
    <!-- 工作单检索弹窗 -->
    <job-no-transcribe-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      @selected="p=>{pm.selectionItemHandler(p)}"
    />
    <!-- 邀请对单弹窗 -->
    <email-input
      v-if="emailInput.visible"
      :visible.sync="emailInput.visible"
      :context="context"
      :job="job"
      source="tabHBL"
      :push-link="SystemConstants.HBL_INVITATION_STATEMENT"
      :is-copy-link="true"
      :job-eamil-data="jobEamilData"
      :send-email-data="emailInput"
      :send-call-back="onEmailExecute"
    />
    <!-- 对单历史弹窗 -->
    <match-history-dialog :visible.sync="matchHistoryDialog.visible" :cargo-doc-uuid="form.uuid" />
    <!-- 抄录弹窗 -->
    <transcribe-dialog :visible.sync="transcribeDialog.visible" :job="job" @callback="transcribeCallback" />
    <!-- 反恐地址格式化弹窗 -->
    <address-format-dialog
      :visible.sync="addressFormatDialog.visible"
      :job="addressFormatDialog.job"
      :params="addressFormatDialog.params"
    />
    <!-- 批量验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 单个验证弹窗 -->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
      :return-main-callback="returnMainCallback"
    />
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="465px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="right">
          <el-form-item :label="$t('SeaExport.ChargeItem')">
            <cargo-advance-select
              no="chargeItemId"
              :select-type="selectTypeNames.basic_data_ChargeItem"
              filterable
              :default-value="editDialog.form.chargeItemId||''"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.chargeItemId=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChargeClause')">
            <cargo-advance-select
              no="paymentTermHBL"
              :select-type="selectTypeNames.basic_data_PaymentTerm"
              filterable
              :default-value="editDialog.form.paymentTermHBL"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.paymentTermHBL=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Currency')">
            <cargo-advance-select
              no="currency"
              :select-type="selectTypeNames.basic_data_Currency"
              filterable
              :default-value="editDialog.form.currency"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.currency=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerSize')">
            <cargo-advance-select
              no="eqSize"
              :select-type="selectTypeNames.local_cache_EQSize"
              :headers="[$t('SeaExport.Code2')]"
              :fields="['code']"
              filterable
              :default-value="editDialog.form.eqSize"
              tag-name="code"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.eqSize=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerType')">
            <cargo-advance-select
              no="eqType"
              :select-type="selectTypeNames.basic_data_EQType"
              :headers="[$t('SeaExport.Code2')]"
              :fields="['code']"
              filterable
              :default-value="editDialog.form.eqType"
              tag-name="code"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.eqType=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Quantity2')">
            <el-input-number
              v-model="editDialog.form.quantity"
              no="quantity"
              :precision="0"
              :controls="false"
              style="width:100%"
              @change="p => {caculateAmount(); pm.changeBillOfLadingSynJob()}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UnitRate')">
            <el-input-number
              v-model="editDialog.form.unitRate"
              no="unitRate"
              :precision="2"
              :controls="false"
              style="width:100%"
              @change="caculateAmount"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Amount')">
            <el-input-number
              v-model="editDialog.form.amount"
              no="amount"
              :precision="2"
              :controls="false"
              style="width:100%"
              @change="editDialog.form.unitRate=editDialog.form.amount"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save2" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel2" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>

    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      :file-size="cloudFile.fileSize"
      :file-category="cloudFile.fileCategory"
      :file-category-label="cloudFile.fileCategoryLabel"
      :upload-source="cloudFile.uploadSource"
      :other-param="cloudFile.otherParam"
      @uploadDone="onUploadDone"
    />
    <el-dialog
      :visible.sync="checkTheBLLog.visible"
      :title="$t('SeaExport.CheckTheBLCenterApiLog')"
      width="1000px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      top="5vh"
      custom-class="details-view settlement-notice"
    >
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-params.sync="checkTheBLLog.gridParams"
            :grid-options="checkTheBLLog.gridOptions"
            :column-defs="checkTheBLLog.columnDefs"
            :row-data="checkTheBLLog.rowData"
          />
        </div>
      </div>
    </el-dialog>
    <xhq-overseas-agent-feedback-dialog
      :visible.sync="xhqOverseasAgentFeedbackDialog.visible"
      :data="xhqOverseasAgentFeedbackDialog.data"
      :callback="xhqOverseasAgentFeedbackDialog.callback"
    />
    <dialog-selector
      :visible.sync="selectorDialog.visible"
      :title="selectorDialog.title"
      :row-data="selectorDialog.rowData"
      @selected="getEDICallback"
    />
    <message-preview-dialog
      :visible.sync="messagePreviewDialog.visible"
      :params="messagePreviewDialog.params"
      @uploadSuccess="p => {}"
    />
    <!--保函上传文件-->
    <guarantee-file-dialog
      :visible.sync="guaranteeFileDialog.visible"
      :model="guaranteeFileDialog.model"
      :title="$t('Message.fileManagement')"
      @saveCallBack="reloadGuaranteePostHandler"
    />
  </div>
</template>

<script>
import { TabHBLPM } from './tabHBLPM'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import jobNoTranscribeDialog from '@/components/Cargo/Job/jobNoTranscribeDialog'
import emailInput from '@/components/Cargo/Job/emailInput'
import matchHistoryDialog from '@/components/Cargo/Job/matchHistoryDialog'
import transcribeDialog from '@/components/Cargo/Job/transcribeDialog'
import addressFormatDialog from '@/views/cargo/v0/SeaExport/components/edi/addressFormatDialog'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as NumberUtils from '@/utils/NumberUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum, mergeArray } from '@/utils/commonUtil'
import { BILL_TYPES } from '@/class/cargo/model/parameters/BillType'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { FreightCharges } from '@/class/model/booking/FreightCharges'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { sendHblCargoDocEmail } from '@/api/sendEmailService'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { manualTriggerAndUpate } from '@/api/seaExport/seaExportJob'
import { executeRuleEngine } from '@/api/seaExport/seaCargoDoc'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { SeaExportUtils } from '@/class/cargo/model/utils/SeaExportUtils'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import URL from '@/api/urlTranslator'
import { Job } from '@/class/model/booking/Job'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { xhqSendCustomerFiles, xhqQueryOverseasAgentFeedback } from '@/api/seaExport/seaCargoDoc'
import { updateTrackingForDocumentType } from '@/api/fileHistory'
import * as AutomaticReleaseConstants from '@/class/cargo/model/parameters/AutomaticReleaseConstants'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import xhqOverseasAgentFeedbackDialog from '@/components/Cargo/Job/xhqOverseasAgentFeedbackDialog'
import {
  INTELLIGENT_DOCUMENT_SOURCE_7
} from '@/class/cargo/model/parameters/SystemConstants'
import { getReleaseEligibleLabel } from '@/utils/releaseEligibility'
import CargoButtonContainer from '@/components/Cargo/Common/cargoButtonContainer'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import * as ediApi from '@/api/seaExport/edi'
import dialogSelector from '@/views/cargo/v0/SeaExport/components/edi/dialogSelector.vue'
import messagePreviewDialog from '@/views/cargo/v0/SeaExport/components/edi/messagePreviewDialog.vue'
import errorLogDialog from '@/views/cargo/v0/SeaExport/components/edi/errorLogDialog.vue'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'
import * as BillReleaseType from '@/class/cargo/model/parameters/BillReleaseType'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import GuaranteeFileDialog from '@/components/Cargo/FileUpload/guaranteeFileDialog.vue'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import * as ExternalFileType from '@/class/cargo/model/parameters/ExternalFileType'
import { isSeparateHsCodeMode } from './seaHsCodeMode'

export default {
  name: 'TabHbl',
  components: {
    errorLogDialog,
    messagePreviewDialog,
    dialogSelector,
    GuaranteeFileDialog,
    CargoButtonContainer,
    CargoRichTextarea, cargoPackingSelect, AutoNumberInput,
    cargoAdvanceSelect, cargoInput, billAddressDialog, jobNoTranscribeDialog, emailInput, matchHistoryDialog,
    transcribeDialog, addressFormatDialog, cargoTemplateSelectorDialog, BatchCheckingWindow, CheckingWindow, specialCharacterTip,
    cargoCloudFileUpload, xhqOverseasAgentFeedbackDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    viewSource: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      billLadingIssued: '',
      SystemConstants,
      CargoDocCfmState,
      jobEamilData: {},
      isZh: this.$store.getters.language === 'zh',
      needInit: true,
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabHBLPM(this),
      moment,
      BILL_TYPES,
      INTELLIGENT_DOCUMENT_SOURCE_7,
      NumberUtils,
      CargoDocUtil,
      selectTypeNames: TYPE_NAMES,
      partnerManagementMode: 0,
      mergeHblData: false,
      synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false,
      syncSignDateBl: false,
      maxChars: 255,
      warningCount: 45,
      englishNameMaxChars: 0,
      markMaxChars: 0,
      englishNameWarningCount: 0,
      markWarningCount: 0,
      btnPrintDisabled: true,
      hblNoDisabled: false,
      cmbtypeHBLDisabled: false,
      isUppercase: true,
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') }
      ],
      otherFieldsData: [],
      addrPM: new BillAddressCommonPM(this),
      job: new SeaExportJob().fillDefaultValue().getData(),
      form: new SeaCargoDoc().fillDefaultValue().getData(),
      chkConsolidationClosed: false,
      otherSelectField: '',
      otherCode: '',
      lblCfrState: '',
      lblReleaseState: '',
      txtCarrierScAc: '',
      txtBookingAgentScAc: '',
      command1: this.$t('SeaExport.CodeSearching'),
      command2: this.$t('SeaExport.InviteToChecktheBL'),
      command3: this.$t('SeaExport.CopyMblConsignee'),
      variableCss: {
        quantity: '',
        shipperLine: '', // 发货人1
        shipperLine1: '', // 发货人1
        shipperLine2: '', // 发货人2
        shipperLine3: '', // 发货人3
        shipperLine4: '', // 发货人4
        shipperLine5: '', // 发货人5
        shipperLine6: '', // 发货人6
        consigneeLine: '', // 收货人1
        consigneeLine1: '', // 收货人1
        consigneeLine2: '', // 收货人2
        consigneeLine3: '', // 收货人3
        consigneeLine4: '', // 收货人4
        consigneeLine5: '', // 收货人5
        consigneeLine6: '', // 收货人6
        notifyLine: '', // 通知人1
        notifyLine1: '', // 通知人1
        notifyLine2: '', // 通知人2
        notifyLine3: '', // 通知人3
        notifyLine4: '', // 通知人4
        notifyLine5: '', // 通知人5
        notifyLine6: '', // 通知人6
        agentPartyLine: '', // 代理信息1
        agentPartyLine1: '', // 代理信息1
        agentPartyLine2: '', // 代理信息2
        agentPartyLine3: '', // 代理信息3
        agentPartyLine4: '', // 代理信息4
        agentPartyLine5: '', // 代理信息5
        agentPartyLine6: '', // 代理信息6
        BLNumber: '', // 提单份数
        packing: '', // 包装
        insideQuantity: '', // 小件数
        insidePacking: '', // 小件数包装类型
        dispatchingPlace: '', // (提单发货地)发货地
        weight: '', // 提单毛重
        cubage: '', // 提单体积
        loadingPort: '', // (提单起运港)装货港
        dischargingPort: '', // (提单卸货港)中转港
        destinationPort: '', // (提单交货地)目的港
        cargoEnglishName: '', // 英文品名
        mark: '', // 唛头
        soNo: '',
        soNoTitle: '',
        vessel: '',
        vesselTitle: '',
        voyageFlight: '',
        voyageFlightTitle: '',
        remarks: ''// 备注
      },
      specialCharCheck: {
        cargoEnglishName: null,
        mark: null,
        shipperLine1: null,
        shipperLine2: null,
        shipperLine3: null,
        shipperLine4: null,
        shipperLine5: null,
        shipperLine6: null,
        consigneeLine1: null,
        consigneeLine2: null,
        consigneeLine3: null,
        consigneeLine4: null,
        consigneeLine5: null,
        consigneeLine6: null,
        notifyLine1: null,
        notifyLine2: null,
        notifyLine3: null,
        notifyLine4: null,
        notifyLine5: null,
        notifyLine6: null
      },
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_ChargeName'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          width: 145,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        }, {
          headerName: this.$t('SeaExport.ChargeClause'),
          colId: 'paymentTermHBL',
          field: 'paymentTermHBL',
          width: 145
        }, {
          headerName: this.$t('SeaExport.Currency'),
          colId: 'currency',
          field: 'currency',
          width: 145
        }, {
          headerName: this.$t('SeaExport.ContainerSize'),
          colId: 'eqSize',
          field: 'eqSize',
          width: 145
        }, {
          headerName: this.$t('SeaExport.ContainerType'),
          colId: 'eqType',
          field: 'eqType',
          width: 145
        }, {
          headerName: this.$t('SeaExport.Quantity2'),
          colId: 'quantity',
          field: 'quantity',
          width: 143,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.UnitRate'),
          colId: 'unitRate',
          field: 'unitRate',
          width: 143,
          cellRenderer: params => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Amount'),
          colId: 'amount',
          field: 'amount',
          width: 143,
          cellRenderer: params => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      autoIncrementNum: new AutoIncrementNum(),
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0, autoUppercase: false, autoHalfWord: false
        }
      },
      billAddressDialog: {
        visible: false
      },
      searchBillNoDialog: {
        visible: false,
        params: {}
      },
      emailInput: {
        visible: false,
        emailTitle: '',
        emailContent: '',
        fileIdList: '',
        overseasLink: ''
      },
      matchHistoryDialog: {
        visible: false
      },
      transcribeDialog: {
        visible: false
      },
      // 反恐舱单-反恐地址格式化-弹窗
      addressFormatDialog: {
        visible: false,
        job: {},
        params: { cargoDocs: [] }
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaCargoDoc(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      returnMainCallback: null, // V1模板返回主页面回调事件
      lob: 'SE',
      pendTabSize: 0, // 当前打开了几个页签
      editDialog: {
        visible: false,
        title: '',
        form: new FreightCharges().fillDefaultValue().getData()
      },
      URL,
      OpenXHQDocumentCenter: false,
      ToExoSystemJYD: false,
      PICtoXHQDocumentCenter: 0,
      IfXHQReleaseRequireHBLReleaseReview: 0,
      cloudFile: {
        visible: false,
        job: new Job(),
        lob: 'SE',
        fileSize: 20480000,
        fileCategory: '',
        fileCategoryLabel: '',
        rowData: [],
        otherParam: {},
        uploadSource: ''
      },
      checkTheBLLog: {
        visible: false,
        jobUuid: '',
        sendType: '',
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          { headerName: this.$t('SeaExport.InterfaceName'), field: 'logSource', flex: 1,
            cellRenderer: (params) => {
              return ColumnUtils.xhqInterfaceLabelFunc(params.value)
            }
          },
          { headerName: this.$t('SeaExport.DataFlowDirection'), field: 'dataFlowDirection', flex: 1,
            cellRenderer: (params) => {
              return ColumnUtils.apiDataFlowDirectionLabelFunc(params.value)
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_SendDate'), field: 'dateCreated', flex: 1 },
          { headerName: this.$t('CargoMsg.Cargo_PushMessage'), field: 'requestMsg', flex: 1 },
          { headerName: this.$t('SeaExport.createdBy'), field: 'createdBy', flex: 1,
            cellRenderer: (params) => {
              if (params.data.dataFlowDirection === SystemConstants.XHQ_TO_CW.code) {
                return '信号旗'
              }
              if (params.value === 999) { // 如果是保存自动触发发送提单更新，后端记录创建人为999，前端转为SYSTEM
                return 'SYSTEM'
              }
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            },
            filterParams: {},
            filterValueGetter: (params) => {
              if (params.data.dataFlowDirection === SystemConstants.XHQ_TO_CW.code) {
                return '信号旗'
              }
              if (params.data.createdBy === 999) { // 如果是保存自动触发发送提单更新，后端记录创建人为999，前端转为SYSTEM
                return 'SYSTEM'
              }
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.data.createdBy, 'chineseName')
            }
          },
          { headerName: this.$t('CargoMsg.RespMsg'), field: 'responseMsg', flex: 1 }
        ],
        rowData: []
      },
      xhqOverseasAgentFeedbackDialog: {
        visible: false,
        data: {},
        callback: null
      },
      guaranteeFileDialog: {
        visible: false,
        model: {}
      },
      showXhqOverseasAgentFeedbackLink: false,
      isDateRequired: false,
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      BillType: BillType,
      // 组件全局变量,
      globalVar: {
        // 业务参数
        selectedJob: null,
        selectedJobKey: null,
        selectedJobs: null,
        selectedJobKeys: null,
        title: '',
        ediType: 0,
        shutOutIdentification: 0,
        editStatus: 0,
        ediTemplate: null,
        ediDatas: null,
        ediTemplateWin: { uuids: null, item: null },
        // 控制参数
        popMultiSegNumRulesType: 1, // 多段参数规则弹窗类型 1:订舱操作引用弹窗 2: 舱单操作引用弹窗
        ediStatusName: '', // 记录按钮发送操作
        sendRPA: false // 发送壹沓RAP
      },
      // 错误日志显示弹窗
      errorLogDialog: {
        visible: false,
        errorLog: ''
      },
      // edi弹窗选择器
      selectorDialog: {
        key: '',
        visible: false,
        title: this.$t('SeaExport.BookingEDI'),
        rowData: []
      },
      // 报文预览弹窗
      messagePreviewDialog: {
        visible: false,
        params: {}
      },
      // 舱单-多段号码规则配置-弹窗
      multiSegNumRulesDialog: {
        visible: false
      },
      longTermGuaranteeState: 0,
      singleTicketGuaranteeState: 0,
      guaranteeConfigEnable: false
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      if (this.action !== 'look' && this.job && this.job.joinFlagHBL && this.job.jointMasterHBLUuid && this.pm.isEditSingleCargoDoc === 0) {
        return false
      } else {
        // const printHblZbLock = this.form.releaseType === 1 && this.form.state === 2 && Number(this.config.get('HBLPrintLockTab')) === 1
        // this.job.printHblZbLock 在其他地方会初始化
        return this.action !== 'look' && this.job && !this.job.printHblZbLock
      }
    },
    btnBLConfirmDisabled() {
      return this.isEdit || !this.form.uuid
    },
    config() {
      return this.context.config
    },
    user() {
      return this.context.user
    },
    // 开航日期
    sailingDate() {
      const val = this.syncSignDateBl ? this.job.atd : this.job.etd
      return val ? moment(val).format('YYYY-MM-DD') : null
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    },
    isDatePickerDisabled() {
      if (this.isEdit) {
        // type类型是普通的或者是否修改过完成时间
        if (((this.job.typeHBL || 1) === BillType.NORMAL_BILL_TYPE.code && !this.form.agreePayDate) || this.isDateRequired) {
          if (this.form.agreePayDate) {
            this.isDateRequired = !this.isDateRequired
          }
          return false
        }
      }
      return true
    },
    isJyd() { // 是否集翊达
      return this.config && String(this.config.get('ToExoSystem')) === 'JYD'
    },
    isTP() { // 是否太平
      return this.config && String(this.config.get('ToExoSystem')) === 'TP'
    },
    isJydEditJobFields() { // 有客服权限，没有操作权限，则不能编辑业务的某些字段【新增业务除外】
      return JobUtils.editJobFields(this.isJyd && this.job.uuid)
    },
    SEHSCodeMode() {
      return this.config ? Number(this.config.get('SEHSCodeMode')) : 0
    },
    syncHblHsCodeEdit() {
      return isSeparateHsCodeMode(this.job && this.job.lob, this.SEHSCodeMode)
    },
    importDifferenceField() {
      if (!this.job) return {}
      return this.job.differenceHblFields || {}
    },
    releaseEligibleLabel() {
      return getReleaseEligibleLabel(this.job && this.job.seaCargoDoc, this.$t, this)
    }
  },
  created() {
    this.context.loading = true
    // await this.context.prepareData()
    this.partnerManagementMode = Number(this.config.get('PartnerManagementMode')) // 是否启用合作伙伴管理模式
    this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.isXy = String(this.config.get('ToExoSystem')) === 'XYCW'
    this.visible = true
    this.context.loading = false
  },
  methods: {
    updateCfm() {
      this.job.hblCfmState = 11
      this.form.cfmState = 11
      this.lblCfrState = ColumnUtils.cfmStatusLabelFunc(this.job.hblCfmState)
    },
    async hsCodeChangeHandle(val) {
      this.job.hsCode = val
      console.log(`[HS_SYNC][HBL] input change mode=${this.SEHSCodeMode} job.hsCode="${this.job.hsCode || ''}" form.hsCode(before)="${this.form.hsCode || ''}"`)
      if (this.job.lob === SystemConstants.SE.code && this.SEHSCodeMode === 0) {
        this.form.hsCode = val
        if (this.job.signMBL) {
          const mblDoc = await new SeaExportJob(this.job).getCargoDocByDocType(CargoDocConsts.MBL, false)
          if (mblDoc) {
            mblDoc.hsCode = val
          }
        }
        console.log(`[HS_SYNC][HBL] synced in mode=0 job.hsCode="${this.job.hsCode || ''}" form.hsCode(after)="${this.form.hsCode || ''}"`)
      }
    },
    isCustomerSelfRelease(val) {
      this.pm.isCustomerSelfRelease(val)
      this.$emit('sinceSingle', this.form.customerSelfRelease)
    },
    isCompanySelfRelease(val) {
      this.pm.isCompanySelfRelease(val)
      this.$emit('sinceSingle', this.form.customerSelfRelease)
    },
    // 保存时，如果未满足放单规则，默认流程不执行后续动作，为了运行下一步，如果勾选了
    // 客户自出单又没有通过放单验证，则自动取消勾选客户自出单
    modifyCustomerSelfRelease() {
      console.log('this.form.customerSelfRelease', this.form.customerSelfRelease)
      this.form.customerSelfRelease = 0
      // 4为待收款
      this.form.releaseState = 4
      this.lblReleaseState = ColumnUtils.releaseStateLabelFunc(this.form.releaseState)
    },
    // 编辑保存时触发放单，通过时接口更新了版本号，重新赋值保存时的HBL版本号
    // cfmState，releaseState修改值，当放单修改数据后，save保存的数据会覆盖放单接口直接修改库的数据，所以需要手动修改传递的值
    updateVersion(val) {
      this.form.version = val
      // 1为可放单
      this.form.releaseState = 1
      this.lblReleaseState = ColumnUtils.releaseStateLabelFunc(this.form.releaseState)
    },
    async onShow(row, isRefresh, pendTabSize) {
      // console.log('btnPrintDisabled', this.btnPrintDisabled)
      this.pendTabSize = pendTabSize
      if (this.needInit) {
        this.needInit = false
        await this.pm.init()
      }
      this.syncSignDateBl = Number(this.config.get('syncSignDateBl')) === 1
      this.job = row
      this.pm.editingChanged()
      await this.pm.changeJob()
      await this.pm.fillView()
      this.pm.display()
      this.lblCfrState = ColumnUtils.cfmStatusLabelFunc(this.form.cfmState)
      this.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
      this.lblReleaseState = ColumnUtils.releaseStateLabelFunc(this.form.releaseState)
      JobUtils.changeField(this.job, this.job.relatedChangeField)
      this.checkField(this.job)
      this.onJobChange()
      if (!isRefresh) {
        this.pm.showCarrierAgentScac()
        // this.pm.refushLoadType()
        this.pm.checkCmbtypeHBLEnabled()
        this.pm.editInputVesselModel()
        if (this.isEdit) {
          this.pm.currentVessel = this.pm.vesselList.filter(p => p.englishName === this.job.vessel)[0]
          await this.pm.getVoyageByVessel()
        }
        return
      }
    },
    onJobChange() {
      // UI自定义中用到
    },
    checkField(job) {
      const titleRed = 'red'
      const red = 'mbl-red'
      this.variableCss.soNo = job.change_soNo ? red : ''
      this.variableCss.soNoTitle = job.change_soNo ? titleRed : ''
      this.variableCss.vessel = job.change_vessel ? red : ''
      this.variableCss.vesselTitle = job.change_vessel ? titleRed : ''
      this.variableCss.voyageFlight = job.change_voyageFlight ? red : ''
      this.variableCss.voyageFlightTitle = job.change_voyageFlight ? titleRed : ''
      this.variableCss.agentPartyLine = ''
      for (let i = 1; i <= 7; ++i) {
        const value = this.job['change_agentPartyLine' + i] ? 'red' : ''
        this.variableCss['agentPartyLine' + i] = value
        if (value === 'red') {
          this.variableCss.agentPartyLine = 'red'
        }
      }
    },
    async getSubmitData() {
      // CARGO-20365先触发富文本组件失焦事件去除尾部换行符
      this.$refs.cargoTextarea1.hanldeFormat()
      this.$refs.cargoTextarea2.hanldeFormat()
      this.validateForm()
      if (this.job.lob === SystemConstants.SE.code && this.SEHSCodeMode === 0) {
        this.form.hsCode = this.job.hsCode
      }
      console.log(`[HS_SYNC][HBL] submit mode=${this.SEHSCodeMode} job.hsCode="${this.job.hsCode || ''}" form.hsCode="${this.form.hsCode || ''}" syncEdit=${this.syncHblHsCodeEdit}`)
      const job = { ...this.job }

      // 不进入并单页签和基本页签也要入库并单数据
      const cargoDocList = await new SeaExportJob(this.job).getSeaCargoDoc()
      let hbl2Uuid = ''
      let hbl2Doc
      for (const e of cargoDocList) {
        if (e.docType === 'HBL2') {
          hbl2Uuid = e.uuid
          hbl2Doc = e
        }
      }
      if (job.typeHBL === BillType.MERGE_BILL_TYPE.code) {
        let hasMergeHbl2 = false
        for (const e of cargoDocList) {
          if (e.docType === CargoDocConsts.HBL2) {
            hasMergeHbl2 = true
          }
        }
        if (!hasMergeHbl2) {
          let hbl2
          if (hbl2Uuid) {
            hbl2.uuid = hbl2Uuid
            hbl2 = hbl2Doc
          } else {
            hbl2 = await CargoDocUtil.onAddHbl2CargoDoc(null, job, this.form)
          }
          this.job.seaCargoDoc.push(hbl2)
        }
      } else if (hbl2Uuid) {
        hbl2Doc.delete = true
        this.job.seaCargoDoc.push(hbl2Doc)
      }
      const data = {
        job,
        seaCargoDoc: this.job.seaCargoDoc,
        afrAddressList: this.chkConsolidationClosed ? this.form.afrAddress : null
      }
      const billOfLadingSynMode = this.config ? parseInt(this.config.get('BillOfLadingSynMode')) : 0
      const expression = this.config ? parseInt(this.config.get('ContainerUpdateJobQCW')) : 0
      const isXyCw = this.config ? String(this.config.get('ToExoSystem')) === 'XYCW' : false
      if (isXyCw && billOfLadingSynMode === 2 && expression === 3 && this.job.containers && this.job.containers.length > 0) {
        data.containers = this.job.containers || []
      }
      return data
    },
    validateForm() {
      this.pm.validateForm()
    },
    executeTask() {
      this.pm.executeTask()
    },
    initCargoDoc(doc, row, docType) {
      new SeaCargoDoc(doc).reset()
      doc.docType = docType
      doc.mark = row.mark
      doc.cargoEnglishName = row.cargoEnglishName
      // if (docType === 'MBL') {
      doc.notifyLine1 = 'SAME AS CONSIGNEE'
      // }
      // 提单发货地，应该是seaopinput.placeOfReceipt
      doc.dispatchingPlace = row.dispatchingPlace
      doc.dispatchingPlaceCode = row.dispatchingPlaceCode
      // 提单起运港
      if (row.loadingPortCode) {
        console.log('posr', this)
        const ports = this.context.seaPortList.filter(p => p.code === row.loadingPortCode)
        if (ports && ports.length > 0) {
          doc.loadingPort = ports[0].englishName
          doc.loadingPortCode = row.loadingPortCode
        }
      }
      // 提单卸货港
      if (row.dischargingPortCode) {
        const ports = this.context.seaPortList.filter(p => p.code === row.dischargingPortCode)
        if (ports && ports.length > 0) {
          doc.dischargingPort = ports[0].englishName
          doc.dischargingPortCode = row.dischargingPortCode
        }
      }
      // 提单目的港
      if (row.destinationPortCode) {
        const ports = this.context.seaPortList.filter(p => p.code === row.destinationPortCode)
        if (ports && ports.length > 0) {
          doc.destinationPort = ports[0].englishName
          doc.destinationPortCode = row.destinationPortCode
        }
      }
      if (doc.docType !== 'MBL' && doc.docType !== 'MBL2') {
        // 提单收货地
        doc.destinationPlace = row.destinationPlace
      }
      if (doc.docType === 'MBL' && row.masterFlag) {
        doc.shipperLine1 = this.office.seaAddressLine1
        doc.shipperLine2 = this.office.seaAddressLine2
        doc.shipperLine3 = this.office.seaAddressLine3
        doc.shipperLine4 = this.office.seaAddressLine4
        doc.shipperLine5 = this.office.seaAddressLine5
        doc.shipperLine6 = this.office.seaAddressLine6
      }
      // 通过参数BillOfLadingSynMode同步件毛体和包装
      CargoDocUtil.changeJobSynToBillOfLading(row, doc)
      // 根据参数判断是否同步小件数包装
      const isInsidePacking = Number(this.config.get('seaInsidePacking'))
      if (isInsidePacking === 1) {
        doc.insidePacking = row.insidePacking
      }
      // doc.issuerBL = 'UBI'
      ColumnUtils.customOrderFormTypeFunc(doc)
      // 新增时，如果已经选择提单方式，会重置为默认值
      if (!doc.releaseType) {
        const releaseType = Number(this.config.get('ReleaseTypeDefaultValue'))
        if (releaseType === 1) {
          doc.releaseType = 1
          doc.blNumber = 'THREE'
        } else if (releaseType === 2) {
          doc.releaseType = 2
          doc.blNumber = 'ONE'
        } else if (releaseType === 3) {
          doc.releaseType = 3
          doc.blNumber = 'ONE'
        } else if (releaseType === 4) {
          let type
          if (doc.docType === 'MBL') {
            type = LocalStorageUtilsNew.getConfiguration('SE_MBL_BL_MODEL')
          } else if (doc.docType === 'HBL') {
            type = LocalStorageUtilsNew.getConfiguration('SE_HBL_BL_MODEL')
          }
          doc.releaseType = type || 1
          doc.BLNumber = 'ONE'
          if (doc.releaseType === 1) {
            doc.BLNumber = 'THREE'
          }
        }
      } else { // 重置提单份数
        if (doc.releaseType === 1) {
          doc.BLNumber = 'THREE'
        } else {
          doc.BLNumber = 'ONE'
        }
      }
      doc.state = 1
    },
    // 下拉菜单
    commandHandle(command) {
      switch (command) {
        case this.$t('SeaExport.CodeSearching'):
          this.billAddressDialog.visible = true
          break
        case this.$t('SeaExport.CopyFromTheLastTime'):
          this.pm.onCopy1()
          break
        case this.$t('SeaExport.CopyFromOtherBill'):
          Object.assign(this.searchBillNoDialog.params, {
            docType: 'HBL',
            selectType: 'single',
            job: this.job
          })
          this.searchBillNoDialog.visible = true
          break
        case this.$t('SeaExport.CopyCargoDescriptionAndMarks'):
          this.transcribeDialog.visible = true
          break
        case this.$t('SeaExport.CopyMbl'):
          this.pm.onCopyMBL()
          break
        case this.$t('SeaExport.InviteToChecktheBL'):
          this.pm.inviteConfirmBL()
          JobUtils.checkBillTip(this.form, this.doInviteConfirmData)
          break
        case this.$t('SeaExport.ConfirmChecking'):
          this.pm.confirmBL()
          break
        case this.$t('SeaExport.CheckingHistory'):
          this.matchHistoryDialog.visible = true
          break
        case this.$t('SeaExport.CopyMblConsignee'):
          this.pm.onCopy_agentParty()
          break
        case this.$t('SeaExport.CopyNominatedAgentInfo'):
          this.pm.onCopy_designationAgent()
          break
        case this.$t('SeaExport.IdentificationList'):
          this.$router.push({
            name: 'OcrRecognition',
            query: {
              uuid: this.job.uuid,
              docUuid: this.form.uuid,
              source: INTELLIGENT_DOCUMENT_SOURCE_7.code
            }
          })
          break
        case this.$t('SeaExport.UploadGuarantee'):
          this.uploadGuaranteeHandler()
          break
      }
    },
    uploadGuaranteeHandler() {
      if (!this.form || !this.form.uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SystemBusyPRL'))
        return
      }
      const params = {}
      params.jobUuid = this.form.jobUuid
      params.jobNo = this.job.jobNo
      params.docUuid = this.form.uuid
      params.hbl = this.form.hblNbr2
      params.uuid = this.form.jobUuid
      params.documentType = ExternalFileType.HBL_SINGLE_TICKET_GUARANTEE.code
      params.documentCategory = DocumentConstants.SINGLE_TICKET_GUARANTEE_NORMAL.code
      this.guaranteeFileDialog.model = params
      this.guaranteeFileDialog.visible = true
    },
    reloadGuaranteePostHandler() {
      this.pm.updateGuaranteeStateInfo()
    },
    doInviteConfirmData() {
      SeaCargoDoc.getCfmAddress(this.form.uuid, this.form.version, this.user.tenantName, this.job.jobNo, this.$store.getters.currentOfficeId, this.user.email).then(data => {
        if (data.cargoDoc) {
          Object.assign(this.form, data.cargoDoc)
          this.pm.docCfmStateChanged()
        }
        this.emailInput.emailTitle = ''
        if (this.form.hblNbr2) {
          this.emailInput.emailTitle = `${this.$t('SeaExport.ConfirmationBillOfLading')}-${this.form.hblNbr2}(${this.context.office.chineseName})`
        } else {
          this.emailInput.emailTitle = `${this.$t('SeaExport.ConfirmationBillOfLading')}(${this.context.office.chineseName})`
        }
        this.emailInput.anonSessionId = data.anonSessionId
        this.emailInput.emailContent = data.url
        this.emailInput.overseasLink = data.overseasLink
        this.emailInput.fileIdList = ''
        this.emailInput.visible = true
        this.jobEamilData = {
          anonSessionId: this.emailInput.anonSessionId,
          jobuuid: this.job.uuid,
          cargoDocUuid: this.form.uuid,
          format: PrintTemplateManager.FORMAT_PDF,
          createdBy: this.$store.getters.userId,
          templateType: this.form.docType,
          className: 'CargoDoc',
          classNameType: SystemConstants.BOOKING,
          officeId: this.$store.getters.currentOfficeId,
          tenantName: this.user.tenantName
        }
      })
    },
    placeholderSFT(i) {
      return JobUtils.placeholderSFT(this.isTP, i)
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.form['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.form['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.form['notifyCode'] = data.notifyCode || ''
      }
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.form['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.form['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.form['notifyLine7'] || '')
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    mergeAgentPartyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['agentPartyLine' + i] || ''
        result += '\n'
      }
      result += (this.form['agentPartyLine7'] || '')
      return result.trimEnd()
    },
    splitAgentPartyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['agentPartyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['agentPartyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['agentPartyLine' + i] = ''
      }
    },
    showShipperDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.Shipper'), this.mergeShipperLine(), this.splitShipperLine, this.notUppercaseShipperConsigneNotify, {
        maxChar: this.maxChars, warningCount: this.warningCount, autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showConsigneeDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.Consignee'), this.mergeConsigneeLine(), this.splitConsigneeLine, this.notUppercaseShipperConsigneNotify, {
        maxChar: this.maxChars, warningCount: this.warningCount, autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showNotifyDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.NotifyParty'), this.mergeNotifyLine(), this.splitNotifyLine, this.notUppercaseShipperConsigneNotify, {
        maxChar: this.maxChars, warningCount: this.warningCount, autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showAgentPartyDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.AgentInfo'), this.mergeAgentPartyLine(), this.splitAgentPartyLine, this.notUppercaseShipperConsigneNotify, {
        maxChar: this.maxChars, warningCount: this.warningCount, autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObj = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0, autoUppercase: false, autoHalfWord: false
      }
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    syncAms(field) {
      const cargoDocs = this.job.seaCargoDoc
      if (!cargoDocs || cargoDocs.length === 0) {
        return
      }
      const amsCargoDoc = []
      for (const item of cargoDocs) {
        if (item.docType === CargoDocConsts.AMS) {
          item[field] = this.form[field]
          amsCargoDoc.push(item)
        }
      }
      this.context.modifiedData.seaCargoDoc = this.context.modifiedData.seaCargoDoc || []
      mergeArray(this.context.modifiedData.seaCargoDoc, amsCargoDoc) // 只记住修改过的数据
    },
    transcribeCallback(data) {
      if (data.hasOwnProperty('cargoEnglishName')) {
        this.form.cargoEnglishName = data.cargoEnglishName
      }
      if (data.hasOwnProperty('mark')) {
        this.form.mark = data.mark
      }
    },
    // 解锁
    unlock() {
      this.pm.onSubmitStateEvent()
      this.form.bliStatus = 0
      this.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
    },
    /**
     * 正本打印
     */
    async checkReleaseRuleEngineState() {
      if (!this.job.uuid) {
        return Number(this.form.releaseState)
      }

      const res = await executeRuleEngine({ jobUuid: this.job.uuid, model: 1 })
      if (res.data && Array.isArray(res.data.seaCargoDocs)) {
        this.job.seaCargoDoc = res.data.seaCargoDocs
        const currentDoc = res.data.seaCargoDocs.find(item => item.uuid === this.form.uuid)
        if (currentDoc) {
          Object.assign(this.form, currentDoc)
          this.job.hblCfmState = this.form.cfmState
          this.pm.docCfmStateChanged()
          this.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
        }
      }
      return Number(res.data.releaseState)
    },
    async originalPrint() {
      // 校验放单状态
      const releaseState = await this.checkReleaseRuleEngineState()

      // 已放单：允许直接进入打印（不再走自动触发/授信弹窗等流程）
      if (releaseState === ReleaseState.ONSINGLERELEASE.code) {
        const params = this.buildHblPrintParams()
        this.openHblPrintDialog(params)
        return
      }

      // HBL 放单状态为”待审核“，点击正本/电放按钮，弹出提示框”不是可放单，无法打印“
      if (Number(this.config.get('CheckHBLReleaseStateBeforePrint')) === 1) {
        // releaseState=1(待审核)/2(已放单) 时允许打印，其它状态拦截
        if (releaseState !== ReleaseState.SINGLERELEASE.code && releaseState !== ReleaseState.ONSINGLERELEASE.code) {
          this.$message.info(this.$t('Message.CheckHBLReleaseStateBeforePrint'))
          return
        }
      }

      // CARGO-40140 电放打印校验是否存在长期保函或者单票保函
      if (this.form.releaseType !== BillReleaseType.ORIGINAL.code && this.guaranteeConfigEnable &&
        this.singleTicketGuaranteeState === SystemConstants.SINGLE_TICKET_GUARANTEE_STATE_NOT_UPLOADED.code &&
        this.longTermGuaranteeState !== SystemConstants.LONG_TERM_GUARANTEE_STATE_INEFFECT.code) {
        this.$message.warning(this.$t('Message.PleaseUploadReleaseGuarantee'))
        return
      }
      if (this.pm.originalPrintCheckSerialNo && this.form.releaseType === 1 && !this.form.serialNo) {
        this.$message.info(this.$t('Message.PleaseInputBlSerialNumberFirst'))
        return
      }
      const dataObj = this.job.seaCargoDoc.find((item) => {
        return item.docType === 'HBL'
      })
      const data = {
        uuid: dataObj.uuid,
        state: 1,
        setting: 0,
        btnType: AutomaticReleaseConstants.HBL_ORIGINAL_PRINTING.code
      }
      this.loading = getLoading()
      const res = await manualTriggerAndUpate(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        if (res.data.result === 2) {
          const messages = []
          const createElement = this.$createElement
          messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.businessNumber') + res.data.jobNo))
          if (res.data.mbl) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.mblNo') + res.data.mbl))
          }
          if (res.data.hbl) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.hblNo') + res.data.hbl))
          }
          if (res.data.tip.accountCompanyName) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.accountCompanyName))
          }
          if (res.data.tip.accountOverCreditLimitDate) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.$t('SeaExport.Exceeded'))))
          }
          if (res.data.tip.accountOverCreditLimitAmount) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.accountOverCreditLimitAmount)))
          }
          if (res.data.tip.agentCompanyName) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.agentCompanyName))
          }
          if (res.data.tip.agentOverCreditLimitDate) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.$t('SeaExport.Exceeded'))))
          }
          if (res.data.tip.agentOverCreditLimitAmount) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.agentOverCreditLimitAmount)))
          }
          if (res.data.tip.customerCompanyName) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.partners') + res.data.tip.customerCompanyName))
          }
          if (res.data.tip.customerOverCreditLimitDate) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.paymentDays').replace('{0}', this.$t('SeaExport.Exceeded'))))
          }
          if (res.data.tip.customerOverCreditLimitAmount) {
            messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.lines').replace('{0}', res.data.tip.customerOverCreditLimitAmount)))
          }
          messages.push(createElement('p', null, this.$t('ReleaseNotes.lineCreditDialog.triggerRemind')))
          await this.$confirm('', {
            title: this.$t('ReleaseNotes.lineCreditDialog.title'),
            message: createElement('div', null, messages),
            confirmButtonText: this.$t('ReleaseNotes.lineCreditDialog.cancel'),
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'warning'
          })
          this.form.releaseState = 4
          this.lblReleaseState = ColumnUtils.releaseStateLabelFunc(this.form.releaseState)
          return
        }
        if (res.data.result === 1) {
          this.$message({
            message: this.$t('ReleaseNotes.lineCreditDialog.through'),
            type: 'success',
            customClass: 'messageIndex'
          })
          this.job.hblCfmState = 10
          this.form.cfmState = 10
          this.lblCfrState = ColumnUtils.cfmStatusLabelFunc(this.job.hblCfmState)
          this.form.releaseState = 2
          this.lblReleaseState = ColumnUtils.releaseStateLabelFunc(this.form.releaseState)
        }
      }
      const params = this.buildHblPrintParams()
      if (this.form.releaseType === 1) {
        const printFunc = () => this.openHblPrintDialog(params)
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_HBLZB_PRINT.code
        const useCheckRule = Number(this.config.get('useCheckRule')) === 1
        const opOffice = this.job.opOffice || 0
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (useCheckRule && hasCheckRule) {
          this.checkingManager(checkNode, printFunc, null)
        } else {
          printFunc()
        }
      } else {
        // 电放打印：按之前诉求跳过校验弹窗，直接进入打印
        this.openHblPrintDialog(params)
      }
    },
    buildHblPrintParams() {
      const params = {}
      params.cargoDocUuid = this.form.uuid
      params.jobuuid = this.job.uuid
      params.DOC_UUID = this.form.uuid
      params.hblNo = this.form.hblNbr2
      params.hblRefNo = this.form.hblRefNo
      // CARGO-6750，SOP回调cargo失败。UUID中有 /导致url匹配不上了
      params.printCallBackUrl = 'services/printExec/entity/update2/CargoDoc?key=' + encodeURIComponent(this.form.uuid) + '&fieldCount=1&field1=state&value1=2'
      if (this.isXy) {
        params.printCallBackUrl = 'services/printExec/entity/update2/CargoDoc?key=' + encodeURIComponent(this.form.uuid) + '&fieldCount=1&field1=state&value1=1'
      }
      return params
    },
    openHblPrintDialog(params) {
      const isOriginal = Number(this.form.releaseType) === 1
      this.templateSelectorDialog.ctx = new SeaCargoDoc(this.form)
      this.templateSelectorDialog.category = isOriginal ? 'HBLZB' : 'HBLDF'
      this.templateSelectorDialog.data = params
      // 组装打印回调函数
      this.prePrintCallback = null
      // CARGO-16750 HBL正本或电放打印 V1模板也增加“是否打印成功”选项
      this.printedCallback = null
      this.returnMainCallback = event => {
        this.pm.print_callback(event)
      }
      this.v2CheckCallback = (isSure, template, entity, arms) => {
        this.pm.v2CheckCallbackFun2(isSure, template, entity, arms)
      }
      this.templateSelectorDialog.visible = true
    },
    /**
     * 验证规则配置公用
     */
    async checkingManager(checkNode, callBack, callBack2) {
      let checkType = true
      if (this.job.masterFlag) {
        const lclSlaves = await new SeaExportJob(this.job).getLclSlaves()
        if (lclSlaves && lclSlaves.length > 0) { // 批量验证
          checkType = false
          const jobs = lclSlaves
          jobs.push(this.job) // 加入主票
          this.batchCheckingWindow.checkNode = checkNode
          this.batchCheckingWindow.jobs = jobs
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.callBack2 = callBack2
          this.batchCheckingWindow.visible = true
        }
      }
      if (checkType) { // 单个验证
        this.checkingWindow.checkNode = checkNode
        this.checkingWindow.callBack = callBack
        this.checkingWindow.callBack2 = callBack2
        this.checkingWindow.visible = true
      }
    },
    showAddressFormatDialog() {
      this.addressFormatDialog.job = {
        dischargingPortCode: this.job.dischargingPortCode,
        etd: this.job.etd
      }
      this.addressFormatDialog.params = { cargoDocs: [this.form] }
      this.addressFormatDialog.visible = true
    },
    showEditDialog(isNew) {
      if (isNew) {
        const newRow = new FreightCharges().fillDefaultValue().getData()
        newRow.cargoDocUuid = this.form.uuid
        this.editDialog.form = newRow
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const cell = this.gridApi.getFocusedCell()
        const row = cell ? this.finalRowData[cell.rowIndex] : undefined
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        if (!row.seq) {
          row.seq = this.autoIncrementNum.getNextNum()
        }
        this.editDialog.form = { ...row }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    caculateAmount() {
      const form = this.editDialog.form
      form.amount = (form.quantity || 0) * (form.unitRate || 0)
    },
    save() {
      const form = this.editDialog.form
      if (!form.seq) {
        this.rowData.push(form)
        setTimeout(() => {
          this.gridApi.setFocusedCell(this.finalRowData.length - 1)
        }, 100)
      } else {
        const row = this.rowData.find(p => p.seq === form.seq)
        if (row) {
          Object.assign(row, form)
          this.gridApi.refreshCells({ force: true })
        }
      }
      this.pm.refershFreightChargeTotal()
      this.editDialog.visible = false
    },
    remove() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.finalRowData[cell.rowIndex] : undefined
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (row.uuid) {
        row.deleted = true
        /* 强制刷新finalRowData */
        const tempRowData = this.rowData
        this.rowData = []
        this.$nextTick(() => {
          this.rowData = tempRowData
        })
      } else {
        const index = this.rowData.findIndex(p => p === row)
        if (index > -1) {
          this.rowData.splice(index, 1)
        }
      }
      this.pm.refershFreightChargeTotal()
    },
    // 组装打印参数
    getPrintData() {
      if (this.job) {
        const params = {}
        params.jobuuid = this.job.uuid
        params.cargoDocUuid = this.form.uuid
        params.DOC_UUID = this.form.uuid
        params.printCallBackUrl = 'services/printExec/sop/update/print_hbl?jobKey=' + encodeURIComponent(this.job.uuid)
        this.templateSelectorDialog.ctx = new SeaCargoDoc(this.form)
        this.templateSelectorDialog.category = 'HBL'
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        this.prePrintCallback = null
        this.printedCallback = event => {
          this.pm.printHblPost(event)
        }
        this.v2CheckCallback = (isSure, template, entity, arms) => {
          this.pm.v2CheckCallbackFun(isSure, template, entity, arms)
        }
        this.templateSelectorDialog.visible = true
      }
      return null
    },
    endTabHandler() {
      this.pm.fillModel()
    },
    /**
     * @private
     * 邀请对单邮件callBack
     * 返回方法
     */
    onEmailExecute(mailSubject, mailTo, mailCc, content, mailType, mailContent, pushLink, customerTypeName) {
      const item = {}
      item.mailTo = mailTo
      item.pushLink = pushLink
      item.mailSubject = mailSubject
      item.mailCc = mailCc
      item.mailType = mailType || ''
      item.mailContent = mailContent || ''
      item.mailBcc = ''
      item.mailFrom = ''
      // item.mailFrom = this.getMailFrom() // 后端已经写死了，此方法无用
      item.cfmUrl = content
      item.anonSessionId = this.emailInput.anonSessionId
      item.jobuuid = this.job.uuid
      item.cargoDocUuid = this.form.uuid
      item.format = PrintTemplateManager.FORMAT_PDF
      item.createdBy = this.$store.getters.userId
      item.templateType = this.form.docType
      item.className = 'CargoDoc'
      item.classNameType = SystemConstants.BOOKING
      item.officeId = this.$store.getters.currentOfficeId
      item.tenantName = this.user.tenantName
      item.customerTypeName = customerTypeName
      item.openXHQDocumentCenter = this.OpenXHQDocumentCenter

      sendHblCargoDocEmail(item).then(res => {
        if (res.ok) {
          this.emailInput.visible = false
          this.$message.success(this.$t('CargoMsg.Cargo_EMSSCM'))
          this.pm.getCfmBillAddressHandler()
        } else {
          this.$message.warning(this.$t('SeaExport.MailSendingFailed'))
        }
      })
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    getClass(key, index) {
      const variableCss = this.variableCss[key + index]
      const shouldWarn = this.warningCount !== -1 && this.form[key + index].length > this.warningCount
      if (variableCss || shouldWarn) {
        return 'red'
      }
      return ''
    },
    getPackingInformation() {
      if (this.job.containerLoadType !== 'BB') {
        this.form.container = SeaExportUtils.getContainerDesc(this.job, false)
      } else {
        this.form.container = SeaExportUtils.getContainerDesc(this.job, this.form.printParam3)
      }
    },
    async XHQDocumentCenterSelectHandler(index) {
      switch (index) {
        case 'InviteToChecktheBL':
          await this.pm.toGetXHQCfmAddress(this.form.uuid).then(data => {
            if (data.cargoDoc) {
              Object.assign(this.form, data.cargoDoc)
              this.pm.docCfmStateChanged()
            }
            this.emailInput.emailTitle = ''
            if (this.form.hblNbr2) {
              this.emailInput.emailTitle = `${this.$t('SeaExport.ConfirmationBillOfLading')}-${this.form.hblNbr2}(${this.context.office.chineseName})`
            } else {
              this.emailInput.emailTitle = `${this.$t('SeaExport.ConfirmationBillOfLading')}(${this.context.office.chineseName})`
            }
            this.emailInput.anonSessionId = data.anonSessionId
            this.emailInput.emailContent = data.url
            this.emailInput.overseasLink = data.overseasLink
            this.emailInput.fileIdList = ''
            this.emailInput.visible = true
            this.jobEamilData = {
              anonSessionId: this.emailInput.anonSessionId,
              jobuuid: this.job.uuid,
              cargoDocUuid: this.form.uuid,
              format: PrintTemplateManager.FORMAT_PDF,
              createdBy: this.$store.getters.userId,
              templateType: this.form.docType,
              className: 'CargoDoc',
              classNameType: SystemConstants.BOOKING,
              officeId: this.$store.getters.currentOfficeId,
              tenantName: this.user.tenantName
            }
          })
          break
        case 'BillOfLadingConfirmationDocument':
          this.pm.toUploadFile('CONFIRMATION OF BILL OF LADING', '提单确认件', 'BILL')
          break
        case 'CustomerSelfIssuedFiles':
          this.pm.toUploadFile('CUSTOMERSELFRELEASE', '客户自出单文件', 'OWN_BILL')
          break
        case 'CheckTheBLLog':
          await this.pm.toCheckTheBLLog()
          break
        case 'ConfirmChecking':
          this.pm.xhqConfirmBL()
          break
        case 'OriginBillOfLading':
          this.pm.toUploadCommonFile('ORIGINAL BILL OF LADING', '正本提单')
          break
        case 'UploadGuarantee':
          this.uploadGuaranteeHandler()
          break
        case 'ShippingOrder':
          this.pm.toUploadFile('SHIPPING_ORDER', '托书文件', 'SHIPPING_ORDER')
          break
        default:
          break
      }
    },
    /**
     * 发送客户文件到信号旗
     */
    onUploadDone(files) {
      if (this.cloudFile.fileCategory === 'ORIGINAL BILL OF LADING') {
        return
      }
      const phone = this.getContactPhone()
      if (!phone) {
        return
      }
      if (!files || !(files.length > 0) || !files[0].fileId) {
        return
      }
      const data = {
        anyStr: this.job.jobNo,
        anyStr1: files[0] ? files[0].fileId : '',
        anyStr2: this.form.hblRefNo,
        anyStr3: phone,
        anyStr4: this.job.uuid,
        anyStr5: files[0] && files[0].params ? files[0].params.xhqSendType : '',
        anyStr6: this.form.uuid,
        anyInteger: this.job.typeHBL,
        anyInteger1: this.job.opOffice
      }
      xhqSendCustomerFiles(data).then(res => {
        if (res.ok) {
          this.$message.success(this.$t('CargoMsg.Cargo_SendSuccess'))
          // 发送成功跟新状态为待制单
          this.form.cfmState = res.data
          this.job.hblCfmState = res.data
          this.lblCfrState = ColumnUtils.cfmStatusLabelFunc(this.job.hblCfmState)
        } else {
          this.$message.warning(res.message)
        }
      })
      this.updateSop(files)
    },
    updateSop(files) {
      // 提取documentTypeUuid
      let docKeys = ''
      if (files) {
        for (const item of files) {
          if (!item.documentTypeUuid) {
            continue
          }
          if (docKeys) {
            docKeys += ','
          }
          docKeys += item.documentTypeUuid
        }
      }
      const objParams = {
        jobUuid: this.cloudFile.job.uuid,
        docKeys: docKeys
      }
      updateTrackingForDocumentType(objParams)
    },
    getContactPhone() {
      let phone = ''
      let userId = 0
      // 推送信号旗单证中心的联系人岗位 0=操作，1=客服，2=单证
      if (this.PICtoXHQDocumentCenter === 1) {
        if (!(this.job.csr > 0)) {
          this.$message.warning(this.$t('SeaExport.PleaseMaintainTheCorresponding', [this.$t('SeaExport.CustomerService')]))
          return
        }
        userId = this.job.csr
      } else if (this.PICtoXHQDocumentCenter === 2) {
        if (!(this.job.dc > 0)) {
          this.$message.warning(this.$t('SeaExport.PleaseMaintainTheCorresponding', [this.$t('SeaExport.Documents')]))
          return
        }
        userId = this.job.dc
      } else {
        if (!(this.job.op > 0)) {
          this.$message.warning(this.$t('SeaExport.PleaseMaintainTheCorresponding', [this.$t('SeaExport.Operation')]))
          return
        }
        userId = this.job.op
      }
      const contact = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', userId)
      if (contact) {
        phone = contact.cell
        if (!phone) {
          this.$message.warning(this.$t('SeaExport.PleaseMaintainThePhoneNumberOfTheCorrespondingPersonnel'))
        }
      }
      return phone
    },
    async xhqShowOverseasAgentFeedbackDialog() {
      await xhqQueryOverseasAgentFeedback({ cargoDocUuid: this.form.uuid }).then(res => {
        if (res.ok) {
          Object.assign(this.xhqOverseasAgentFeedbackDialog.data, res.data)
          this.xhqOverseasAgentFeedbackDialog.data.jobUuid = this.job.uuid
        }
      })
      this.xhqOverseasAgentFeedbackDialog.callback = this.xhqOverseasAgentFeedbackCallback
      this.xhqOverseasAgentFeedbackDialog.visible = true
    },
    xhqOverseasAgentFeedbackCallback(flg) {
      if (flg) {
        this.form.shipperLine1 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine1
        this.form.shipperLine2 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine2
        this.form.shipperLine3 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine3
        this.form.shipperLine4 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine4
        this.form.shipperLine5 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine5
        this.form.shipperLine6 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine6
        this.form.shipperLine7 = this.xhqOverseasAgentFeedbackDialog.data.feedbackShipperLine7
        this.form.consigneeLine1 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine1
        this.form.consigneeLine2 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine2
        this.form.consigneeLine3 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine3
        this.form.consigneeLine4 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine4
        this.form.consigneeLine5 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine5
        this.form.consigneeLine6 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine6
        this.form.consigneeLine7 = this.xhqOverseasAgentFeedbackDialog.data.feedbackConsigneeLine7
        this.form.notifyLine1 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine1
        this.form.notifyLine2 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine2
        this.form.notifyLine3 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine3
        this.form.notifyLine4 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine4
        this.form.notifyLine5 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine5
        this.form.notifyLine6 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine6
        this.form.notifyLine7 = this.xhqOverseasAgentFeedbackDialog.data.feedbackNotifyLine7
        this.form.loadingPort = this.xhqOverseasAgentFeedbackDialog.data.feedbackLoadingPort
        this.form.dischargingPort = this.xhqOverseasAgentFeedbackDialog.data.feedbackDischargingPort
        this.form.destinationPort = this.xhqOverseasAgentFeedbackDialog.data.feedbackDestinationPort
        this.form.cargoEnglishName = this.xhqOverseasAgentFeedbackDialog.data.feedbackCargoEnglishName
        this.form.mark = this.xhqOverseasAgentFeedbackDialog.data.feedbackMark
      }
    },
    onIdentificationList() {
      this.$router.push({
        name: 'OcrRecognition',
        query: {
          uuid: this.job.uuid,
          docUuid: this.form.uuid,
          source: INTELLIGENT_DOCUMENT_SOURCE_7.code
        }
      })
    },
    // 对单链接 0：客户地址 1：指定货地址
    onOpenDocLink(type) {
      JobUtils.openDocLink(this.form.uuid, type)
    },
    downloadAttachment(regionWarehouseMappingUuid) {
      JobUtils.downloadPortRequirementAttachment(regionWarehouseMappingUuid)
    },
    handleDateChange() {
      this.isDateRequired = !this.isDateRequired
      if (this.form.agreePayDate) {
        this.form.releaseReview = 1
        this.form.payable = true
      } else {
        this.form.releaseReview = 0
        this.form.payable = false
      }
    },
    // 海外代理预报
    toOverseaAgeFore(index) {
      this.selectorDialog.key = 'bl'
      switch (index) {
        case this.$t('SeaExport.Original'):
          this.globalVar.title = this.$t('SeaExport.Original') + this.$t('SeaExport.JclForecast')
          this.globalVar.ediStatusName = this.$t('SeaExport.Original')
          this.jclHandler(9)
          break
        case this.$t('SeaExport.Correct'):
          this.globalVar.title = this.$t('SeaExport.Correct') + this.$t('SeaExport.JclForecast')
          this.globalVar.ediStatusName = this.$t('SeaExport.Correct')
          this.jclHandler(5)
          break
        case this.$t('CargoMsg.Cargo_Delete'):
          this.globalVar.title = this.$t('CargoMsg.Cargo_Delete') + this.$t('SeaExport.JclForecast')
          this.globalVar.ediStatusName = this.$t('CargoMsg.Cargo_Delete')
          this.jclHandler(1)
          break
        default:
          break
      }
    },
    // 预配舱单操作处理器
    jclHandler(state) {
      JobUtils.common(this).getSelectedJobs()
      this.globalVar.editStatus = state
      this.globalVar.ediType = EdiType.JCL_EDI_TYPE.code
      this.globalVar.ediTemplate = {}
      this.globalVar.ediTemplate.defaultFileType = '.xml'
      if (JobUtils.common(this).checkConfig('useEDITemplate', '1')) {
        JobUtils.common(this).showEDITemplateWin([this.job.uuid])
      } else {
        const params = { jobUuids: [this.job.uuid], editStatus: this.globalVar.editStatus, ediType: this.globalVar.ediType, templateId: this.globalVar.ediTemplate.uuid }
        this.loading = getLoading4Cxt(this)
        ediApi.getEDI(params).then(response => {
          JobUtils.commonCallback(this).onExportEDISuccess(response)
        }).catch(err => {
          JobUtils.commonCallback(this).onExportEDIFail(err)
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // EDI模板选择弹窗(dialog-selector)选择数据后回调函数
    getEDICallback(row) {
      this.globalVar.ediTemplate = row
      this.globalVar.popMultiSegNumRulesType = 1
      if (JobUtils.common(this).checkConfig('EDINoRuleConfigMode', '1') && this.globalVar.ediType === 5) {
        this.multiSegNumRulesDialog.visible = true
      } else {
        JobUtils.multiSegNumRulesCallback(null, this)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mbl-red::v-deep{
  .el-input__inner {
    color: red !important;
  }
}
.triggers{
  .operat-wrap{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    .el-checkbox{
      margin-right: 15px;
      &:first-of-type{
        margin-left: 20px;
      }
    }
  }
}
.form-column{
  .form-item-input{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid #E4E7ED;
    span{
      width: 40px;
      height: 28px;
      line-height: 26px;
      box-sizing: border-box;
      padding-left: 5px;
      padding-top: 1px;
    }
    /deep/ input{
      border: 0;
      padding-right: 0 !important;
    }
  }
  .input-disabled{
    background-color: #f0f3f8 !important;
    cursor: not-allowed;
  }
}
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea{
    border: 1px solid red !important;
  }
}

</style>
<style>
.messageIndex{
  z-index:99999 !important;
}
</style>
